<template>
  <div class="product-card" :class="{ 'with-promo' : !!(data.offer.text) }">
    <div class="card">
      <a :href="data.permalink" class="product-link"></a>
      <div class="promotion" :class="[data.offer.style]" v-if="data.offer.text">{{ data.offer.text }}</div>
      <div class="tag" v-if="data.tag">{{ data.tag }}</div>
      <div class="colors">
        <span class="color" v-for="(color, index) in data.colors" :key="index" :style="{ backgroundColor: '#' + color.hex }"></span>
      </div>
      <div class="picture">
        <img :src="data.pictures[0]" :alt="data.name" v-if="data.pictures.length && data.pictures[0]">
      </div>
      <div class="right">
        <div class="name"><h2>{{ data.name }}</h2></div>
        <div class="storages" v-if="storages.length">
          <span class="storage" v-for="(storage, index) in storages" :key="index">{{ storage }}</span>
        </div>
        <div class="price">
          <div class="price-package">
            <p class="amount" v-html="data.prices.display"></p>
            <p class="subscription" v-if="data.subscription">Avec {{ data.subscription }}</p>
          </div>
          <div class="price-alone" v-if="data.subscription">
            <p>Prix seul <span v-html="data.prices.alone"></span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    data: Object
  },
  computed: {
    storages () {
      const storages = []

      this.data.storages.forEach((item) => {
        if(item.capacite) {
          storages.push(item.capacite + ' ' + item.unit.toLowerCase())
        }
      })

      return storages
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/tools/*';
@import '../../../../scss/mixins/*';

.product-card{
  position: relative;
  z-index: 0;
  width: 100%;
  height: auto;

  &:before, &:after{
    content: '';
    display: block;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    @include radius(10px);
    @include transition(All 0.15s);
  }

  &:before{
    height: 100%;
    z-index: -1;
    background-color: $white;
    border: 2px solid rgba($black, 0.1);
  }

  &:after {
    height: 90%;
    background-color: $primary;
    opacity: 0;
    z-index: -2;
  }

  &:hover {

    &:before{
      border: 2px solid $primary;
      @include transform(translateY(-3px) translateX(-5px));

      @include responsive(mobile) {
        border: 2px solid rgba($white, 0);
        @include transform(translateY(0) translateX(0));
      }
    }

    &:after {
      opacity: 1;
      @include transform(translateY(3px) translateX(3px));

      @include responsive(mobile) {
        opacity: 0;
        @include transform(translateY(0) translateX(0));
      }
    }
  }

  .card {
    position: relative;
    min-height: 520px;
    padding: 30px 30px 170px 35px;

    @include responsive(mobile) {
      display: grid;
      grid-template-columns: 100px 1fr;
      grid-column-gap: 20px;
      min-height: auto;
      padding: 20px 20px 10px 30px;
    }

    .promotion{
      position: absolute;
      left: 0;
      top: 150px;
      width: auto;
      background-color: $turquoise;
      color: $black;
      font-size: px2rem(13px);
      font-weight: $fontBold;
      z-index: 10;
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      border: 1px solid $white;
      border-left: 0;
      @include box-sizing();
      @include radius(18px, 'right');

      &.yellow{
        background-color: $yellow;
      }
    }

    .tag{
      width: auto;
      position: absolute;
      right: 30px;
      top: 30px;
      background-color: $primary;
      color: $white;
      font-family: $headingsFont;
      font-size: px2rem(15px);
      font-weight: $fontMedium;
      z-index: 10;
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      @include box-sizing();
      @include radius(18px);

      @include responsive(mobile) {
        right: 40px;
        top: -10px;
      }
    }

    a.product-link {
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
    }

    .colors {
      display: inline-block;
      position: absolute;
      left: 10px;
      top: 10px;
      width: 20px;
      height: auto;

      @include responsive(mobile) {
        top: 50%;
        left: -10px;
        @include transform(translateY(-50%));
      }

      span.color {
        display: inline-block;
        width: 14px;
        height: 14px;
        margin: 3px 3px 3px 5px;
        border: 1px solid darken($white, 20%);
        @include box-sizing();
        @include radius(100%);
      }
    }

    .picture {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 230px;
      margin-bottom: 20px;

      @include responsive(mobile) {
        margin-bottom: 0;
      }

      img {
        display: inline-block;
        width: auto;
        height: auto;
        max-width: 165px;
        max-height: 226px;

        @include responsive(mobile) {
          max-width: 200px;
          max-height: 150px;
        }
      }
    }

    .name{
      text-align: center;

      @include responsive(mobile) {
        padding-top: 10px;
      }

      h2 {
        display: block;
        width: 100%;
        font-size: px2rem(18px);
        line-height: px2rem(24px);
        font-weight: $fontSemiBold;
        color: $black;
        padding: 0;

        @include responsive(mobile) {
          font-size: px2rem(15px);
          line-height: px2rem(20px);
        }
      }
    }

    .storages{
      text-align: center;

      @include responsive(mobile) {
        margin-top: 5px;
      }

      span.storage{
        display: inline-block;
        height: 24px;
        line-height: 20px;
        padding: 0 5px;
        margin: 5px;
        border: 2px solid rgba($black, 0.1);
        text-transform: capitalize;
        font-weight: $fontBold;
        @include box-sizing();
        @include radius(3px);

        @include responsive(mobile) {
          margin-left: 0;
          margin-top: 0;
        }
      }
    }

    .price{
      position: absolute;
      bottom: 30px;
      left: 0;
      padding: 0 30px;

      @include responsive(mobile) {
        position: relative;
        bottom: initial;
        left: initial;
        padding: 0;
        grid-column: span 2;
      }

      .price-package{
        text-align: center;

        p.amount{
          padding: 20px 0 5px 0;
          text-transform: none;
          color: $primary;
          font-weight: $fontSemiBold;
          font-size: px2rem(28px);

          @include responsive(mobile) {
            padding: 20px 0 5px 0;
            font-size: px2rem(24px);
          }
        }

        p.subscription{
          display: inline-block;
          padding: 0 0 20px 0;
          max-width: 200px;
          line-height: px2rem(18px);
          float: none;

          @include responsive(mobile) {
            font-size: px2rem(13px);
            line-height: px2rem(18px);
          }
        }
      }

      .price-alone{
        text-align: center;

        p{
          font-size: px2rem(14px);
          color: rgba($black, 0.8);
          text-transform: none;
          line-height: px2rem(16px);
          margin: 0 auto;

          @include responsive(mobile) {
            font-size: px2rem(13px);
            line-height: px2rem(18px);
          }
        }
      }
    }
  }
}
</style>
